braintree = require('braintree-web')
angular.module('rjmNg.directives').directive('billing', [
  () ->
    restrict: 'E'
    templateUrl: 'settings/directive.billing.html'
    replace: true
    scope: {}
    controllerAs: 'view'
    bindToController: true
    require: "^?rjmUi"
    controller: [
      '$anchorScroll'
      '$q'
      '$routeParams'
      '$timeout'
      'notification'
      "Billing"
      "Clients"
      "FEATURE_TIER"
      (
        $anchorScroll
        $q
        $routeParams
        $timeout
        notification
        Billing
        Clients
        FEATURE_TIER
      ) ->
        view = @
        view.hostedFieldsInstance = null
        view.loading = true
        view.activeInNetsuite = false
        view.clientId = $routeParams.clientId
        view.defaultPaymentMethod = null
        view.showPaymentForm = false
        view.isEssentialsClient = false
        view.featureTier = null
        view.billingTier = null
        view.monthlyRate = null
        view.freeTrialEndDate = null
        view.freeTrialActive = false
        view.nextBillingDate = null
        view.hasMagentoSubscription = false

        view.cancelSubscription = ->
          Intercom("showNewMessage", "I'd like to cancel my subscription, please.")
        view.upgradeToPro = ->
          Intercom("showNewMessage", "I'm interested in upgrading to Adobe Commerce Intelligence Pro.")

        BRAINTREE_HOSTED_FIELDS_CONFIG =
          styles:
            input:
              "font-size": "14pt"
            "input.invalid":
              color: "red"
            "input.valid":
              color: "green"
          fields:
            number:
              selector: '#card-number'
            cvv:
              selector: '#cvv'
            expirationDate:
              selector: '#expiration-date',
              placeholder: 'MM/YYYY'
            postalCode:
              selector: '#postal-code'

        _getBraintreeHostedFieldsError = ({code}) ->
          switch code
            when "HOSTED_FIELDS_FIELDS_EMPTY" then "All fields are empty! Please fill out the form."
            when "HOSTED_FIELDS_FIELDS_INVALID" then "Some fields are invalid or empty. Please correct, and try again."
            when "HOSTED_FIELDS_FAILED_TOKENIZATION" then "We failed to process your card. Please double check your credit card information."
            else "We failed to submit your credit card information. Please contact support."

        _init = (clientInfo, initPaymentForm = false) ->
          $q.all([Billing.getStatus(view.clientId)
                  # Billing.getPaymentMethods(view.clientId)
                  Billing.getTiers()])
          .then ([status, 
                  # paymentMethods, 
                  billingTiers]) ->
            {Message, NetsuiteStatus, isActive} = status

            view.isEssentialsClient = clientInfo.properties?.feature_tier is FEATURE_TIER.BASIC.toString()
            view.featureTier = if view.isEssentialsClient then 'Adobe Commerce Intelligence Essentials' else 'Adobe Commerce Intelligence Pro'
            billingTier = billingTiers.filter (t) -> t.id == clientInfo.properties.billing_tier
            view.billingTier = billingTier[0]?.description
            view.monthlyRate = billingTier[0]?.price
            
            if status.free_trial?.days_remaining?
              view.freeTrialActive = status.free_trial.days_remaining > 0
            if status.free_trial?.end_date?
              view.freeTrialEndDate = moment.utc(status.free_trial.end_date).format("MMMM DD, YYYY")
            if status.next_payment_date?
              view.nextBillingDate = moment.utc(status.next_payment_date).format("MMMM DD, YYYY")

        #     # can't talk to netsuite so can't determine the billing status - show an error
        #     if NetsuiteStatus is "error" and Message is "Unable to access Netsuite"
        #       notification.error(null, "Failed to load your billing information. Please try again or contact support.", "billing")
        #       $anchorScroll()
        #       return

            defaultPaymentMethod = [] # paymentMethods.filter((pm) -> pm.default)

            view.defaultPaymentMethod = if defaultPaymentMethod.length then defaultPaymentMethod[0]
            view.activeInNetsuite = isActive is "true"

            if view.activeInNetsuite and
              not view.defaultPaymentMethod and
              initPaymentForm and
                view.loadPaymentForm()
            else
              view.loading = false
          .catch (error) ->
            view.loading = false
            notification.error(null, "Failed to load your billing information. Please try again or contact support.", "billing")

        _setBillingStateWithSubscription = (clientInfo, status, billingTiers) ->
          view.hasMagentoSubscription = true
          view.isEssentialsClient = clientInfo.properties?.feature_tier is FEATURE_TIER.BASIC.toString()
          view.featureTier = if view.isEssentialsClient then 'Adobe Commerce Intelligence Essentials' else 'Adobe Commerce Intelligence Pro'
          billingTier = billingTiers.filter (t) -> t.id == clientInfo.properties.billing_tier
          view.billingTier = billingTier[0]?.description
          view.monthlyRate = billingTier[0]?.price

          if status.free_trial?.days_remaining?
            view.freeTrialActive = status.free_trial.days_remaining > 0
          if status.free_trial?.end_date?
            view.freeTrialEndDate = moment.utc(status.free_trial.end_date).format("MMMM DD, YYYY")

        _initWithSubscription = (clientInfo) ->
          $q.all([Billing.getSubscriptionStatus(view.clientId)
                  Billing.getTiers()])
          .then ([status, billingTiers]) ->
            _setBillingStateWithSubscription(clientInfo, status, billingTiers)
            view.loading = false
          .catch (error) ->
            view.loading = false
            notification.error(null, "Failed to load your billing information. Please try again or contact support.", "billing")

        _initWithClientInfo = (initPaymentForm = false) ->
          Clients.get(view.clientId)
          .then (clientInfo) ->
            if clientInfo.properties.magento_subscription_id? and
              clientInfo?.properties?.magento_subscription_id isnt ""
                _initWithSubscription(clientInfo)
            else
              _init(clientInfo, initPaymentForm)
          .catch (error) ->
            view.loading = false
            notification.error(null, "Failed to load your billing information. Please try again or contact support.", "billing")

        #### DISABLE AS A PART OF REMOVING BILLING/SUBSCRIPTION DEPENDENCY #####
        # _createPayment = (nonce) ->
        #   Billing.createPaymentMethod(view.clientId, nonce)
        #   .then (response) ->
        #     view.loading = false
        #     view.showPaymentForm = false
        #     _initWithClientInfo(false)
        #     notification.success(null, "Payment method has been successfully updated", "billing")
        #   .catch ({data}) ->
        #     view.loading = false
        #     if data?.error is "braintree_verification"
        #       notification.error "Error.", "There was a problem processing your credit card. please double check your payment information and try again.", "billing"
        #     else
        #       notification.error "Error.", "We've encountered an error while submitting your payment method. Please try again, or contact support.", "billing"

        # view.submitPaymentMethod = () ->
        #   notification.clear("billing")
        #   view.loading = true
        #   view.hostedFieldsInstance.tokenize( (tokenizeErr, payload) ->
        #     if tokenizeErr
        #       $timeout view.loading = false
        #       # need a timeout here because angular has no knowledge of an async call happening
        #       $timeout notification.error(null, _getBraintreeHostedFieldsError(tokenizeErr), "billing")
        #       for field in tokenizeErr.details.invalidFieldKeys
        #         view.hostedFieldsInstance.addClass(field, 'invalid')              
        #       $anchorScroll()
        #       return
        #     _createPayment(payload.nonce)
        #     $anchorScroll()
        #   )
        #### DISABLE AS A PART OF REMOVING BILLING/SUBSCRIPTION DEPENDENCY #####

        # view.loadPaymentForm = () ->
        #   view.showPaymentForm = true
        #   view.loading = true
        #   braintreeClientCreateCallback = (clientErr, clientInstance) ->
        #     if clientErr
        #       $timeout view.loading = false
        #       # need a timeout here because angular has no knowledge of an async call happening
        #       $timeout notification.error(null, "Failed to load the payment form. Please try again or contact support.", "billing")
        #       $anchorScroll()
        #       return

        #     hostedFieldsConfig = angular.extend({}, BRAINTREE_HOSTED_FIELDS_CONFIG, {client: clientInstance})

        #     braintree.hostedFields.create(
        #       hostedFieldsConfig
        #     , (hostedFieldsErr, hostedFieldsInstance) ->
        #       $timeout view.loading = false
        #       if hostedFieldsErr
        #         # need a timeout here because angular has no knowledge of an async call happening
        #         $timeout notification.error(null, "Failed to load the payment form. Please try again or contact support.", "billing")
        #         $anchorScroll()
        #         return
        #       view.hostedFieldsInstance = hostedFieldsInstance
        #     )

        #   Billing.generateClientToken(view.clientId)
        #   .then ({token}) ->
        #     braintree.client.create(
        #       authorization: token
        #       braintreeClientCreateCallback
        #     )

        @$onInit = ->
          _initWithClientInfo(true)

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "clientSettings", scope.view.loading

])
